exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alegreya:ital,wght@0,400;0,500;0,700;0,800;0,900;1,400;1,500;1,700;1,800;1,900&display=swap);", ""]);

// module
exports.push([module.id, ".commentModalSubmitBtn {\n  background-color: #53005C;\n  color: #F8F8F8;\n  border: 1px #53005C solid; }\n  .commentModalSubmitBtn:hover {\n    background-color: transparent;\n    color: #53005C;\n    border: 1px #53005C solid; }\n\n.commentModal {\n  font-family: 'Alegreya', serif;\n  font-weight: 500;\n  border: 1px solid; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Comments/commentModal.scss
// module id = 390
// module chunks = 0